import { Col, Row } from 'react-bootstrap';
import React, { useContext, useEffect } from 'react';
import img from '../../../assets/Img';
import { useTranslation } from 'react-i18next';
import '../seo.css';
import '../Service/scervice.scss';
import ServicesSlider from '../ServicesSlider';
import DocumentaryCard from './DocumentaryCard';
import EventServices from './EventServices';
import WhyChooseRightClick from './../branding/WhyChooseRightClick';
import Component from '../../../constants/Component';
import SocialMediaSection2 from './SocialMediaSection2';

const translations = {
    en: require('../../../Translate/en.json').VisualProduction,
    ar: require('../../../Translate/ar.json').VisualProduction,
};

const VisualProduction = () => {
    const { i18n } = useTranslation();
    const isLang = i18n.language;
    const t = translations[isLang || 'en'];

    const data = {
        img: img.VisualProduction,
        title: t.title,
        dec: t.dec,
        title2: t.title2,
        dec2: t.dec2
    };

    const benefits = [
        {
            title: isLang === 'ar' ? "خبرة موثوقة:" : "Experience You Can Trust:",
            description: isLang === 'ar'
                ? "أكثر من 10 سنوات في مساعدة الشركات على النجاح عبر الإنترنت."
                : "Over 10 years of helping businesses like yours succeed online.",
        },
        {
            title: isLang === 'ar' ? "حلول مخصصة:" : "Tailored Solutions:",
            description: isLang === 'ar'
                ? "كل استراتيجية مصممة خصيصًا لتناسب احتياجات وأهداف عملك."
                : "Every strategy is customized to fit your business needs and goals.",
        },
        {
            title: isLang === 'ar' ? "نتائج حقيقية:" : "Real Results:",
            description: isLang === 'ar'
                ? "نركز على تحقيق نمو ملموس من حيث الزيارات والعائدات."
                : "We focus on driving measurable growth, from traffic to revenue.",
        },
        {
            title: isLang === 'ar' ? "شركاؤك في النمو:" : "Your Growth Partners:",
            description: isLang === 'ar'
                ? "نحن معك في كل خطوة لضمان نجاحك في السوق التنافسي."
                : "We're here to guide you every step of the way, ensuring your success in a competitive market.",
        }
    ];
    useEffect(() => {
        window.scroll(0, 0)
    }, [])

    return (
        <div className="VisualProduction overflow-hidden">
            <ServicesSlider t={t} data={data} />

            <div className="documentary-container">
                <DocumentaryCard />
            </div>

            <div className="services-section">
                <Row align="middle">
                    {/* Events Coverage Section */}
                    <Col xs={12} md={6} className="flex justify-content-start align-items-start">
                        <img
                            width={500}
                            height={300}
                            src={img.VisualProductionservice}
                            alt="Visual Service"
                            className="service-image"
                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <EventServices />
                    </Col>
                </Row>
            </div>

            <div className="my-5">
                <img
                    src={img.VisualProductionbg}
                    alt="Visual Production Background"
                    className="w-100 h-100"
                />
            </div>
            <SocialMediaSection2 />
            <WhyChooseRightClick benefits={benefits} />
            <Component.ContactUSHome />
        </div>
    );
};

export default VisualProduction;
